const optionsMarcasMotos = [
	{ id: 'ACELLERA', name: 'Acellera' },
	{ id: 'ADLY', name: 'Adly' },
	{ id: 'AMAZONAS', name: 'Amazonas' },
	{ id: 'APRILIA', name: 'Aprilia' },
	{ id: 'ARIEL', name: 'Ariel' },
	{ id: 'ATALA', name: 'Atala' },
	{ id: 'BAJAJ', name: 'Bajaj' },
	{ id: 'BENELLI', name: 'Benelli' },
	{ id: 'BETA', name: 'Beta' },
	{ id: 'BIMOTA', name: 'Bimota' },
	{ id: 'BIRELLI', name: 'Birelli' },
	{ id: 'BRANDY', name: 'Brandy' },
	{ id: 'BRAVA', name: 'Brava' },
	{ id: 'BRAVAX', name: 'Bravax' },
	{ id: 'BRP', name: 'BRP' },
	{ id: 'BUELL', name: 'Buell' },
	{ id: 'BUENO', name: 'Bueno' },
	{ id: 'BULL', name: 'Bull' },
	{ id: 'CAGIVA', name: 'Cagiva' },
	{ id: 'CAN-AM', name: 'CAN-AM' },
	{ id: 'DAELIM', name: 'Daelim' },
	{ id: 'DAFRA', name: 'Dafra' },
	{ id: 'DAYANG', name: 'Dayang' },
	{ id: 'DAYUN', name: 'Dayun' },
	{ id: 'DERBI', name: 'Derbi' },
	{ id: 'DUCAR', name: 'Ducar' },
	{ id: 'DUCATI', name: 'Ducati' },
	{ id: 'EMME', name: 'EMME' },
	{ id: 'FBM', name: 'FBM' },
	{ id: 'FYM', name: 'FYM' },
	{ id: 'GARELLI', name: 'Garelli' },
	{ id: 'GARINNI', name: 'Garinni' },
	{ id: 'GARRA', name: 'Garra' },
	{ id: 'GAS-GAS', name: 'GAS-GAS' },
	{ id: 'GREEN', name: 'Green' },
	{ id: 'HAOBAO', name: 'Haobao' },
	{ id: 'HARLEY-DAVIDSON', name: 'Harley-Davidson' },
	{ id: 'HARTFORD', name: 'Hartford' },
	{ id: 'HERO', name: 'Hero' },
	{ id: 'HUSABERG', name: 'Husaberg' },
	{ id: 'HUSQVARNA', name: 'Husqvarna' },
	{ id: 'INDIAN', name: 'Indian' },
	{ id: 'IROS', name: 'IROS' },
	{ id: 'JAWA', name: 'JAWA' },
	{ id: 'JIAPENG-VOLCANO', name: 'Jiapeng-Volcano' },
	{ id: 'JOHNNYPAG', name: 'Johnnypag' },
	{ id: 'JONNY', name: 'Jonny' },
	{ id: 'KAHENA', name: 'Kahena' },
	{ id: 'KASINSKI', name: 'Kasinski' },
	{ id: 'KAWASAKI', name: 'Kawasaki' },
	{ id: 'KIMCO', name: 'Kimco' },
	{ id: 'KTM', name: 'KTM' },
	{ id: 'LAMBRETA', name: 'Lambreta' },
	{ id: 'LANDUM', name: 'Landum' },
	{ id: 'LAQUILA', name: 'Laquila' },
	{ id: 'LAVRALE', name: 'Lavrale' },
	{ id: 'LEOPARD', name: 'Leopard' },
	{ id: 'LERIVO', name: 'Lerivo' },
	{ id: 'LIFAN', name: 'Lifan' },
	{ id: 'LON-V', name: 'LON-V' },
	{ id: 'MALAGUTI', name: 'Malaguti' },
	{ id: 'MARVA', name: 'Marva' },
	{ id: 'MIZA', name: 'Miza' },
	{ id: 'MOBILETE', name: 'Mobilete' },
	{ id: 'MOTO-GUZZI', name: 'Moto-Guzzi' },
	{ id: 'MRX', name: 'MRX' },
	{ id: 'MV-AUGUSTA', name: 'MV-Augusta' },
	{ id: 'MVK', name: 'MVK' },
	{ id: 'ORCA', name: 'Orca' },
	{ id: 'PEGASSI', name: 'Pegassi' },
	{ id: 'PIAGGIO', name: 'Piaggio' },
	{ id: 'POLARIS', name: 'Polaris' },
	{ id: 'REGAL-RAPTOR', name: 'Regal-Raptor' },
	{ id: 'SANYANG', name: 'Sanyang' },
	{ id: 'SCOOTER', name: 'Scooter' },
	{ id: 'SIAMOTO', name: 'Siamoto' },
	{ id: 'SUNDOWN', name: 'Sundown' },
	{ id: 'TARGOS', name: 'Targos' },
	{ id: 'TRAXX', name: 'Traxx' },
	{ id: 'TRICICLO', name: 'Triciclo' },
	{ id: 'TRICKER', name: 'Tricker' },
	{ id: 'VENTO', name: 'Vento' },
	{ id: 'VICTORY', name: 'Victory' },
	{ id: 'WALK-MACHINE', name: 'Walk-Machine' },
	{ id: 'WOLVER', name: 'Wolver' },
	{ id: 'WUYANG', name: 'Wuyang' },
	{ id: 'X-MOTOS', name: 'X-Motos' },
	{ id: 'YAMAHA', name: 'Yamaha' },
	{ id: 'ZONGSHEN', name: 'Zongshen' },
];

const optionsMarcasCarros = [
	{ id: 'ACURA', name: 'Acura' },
	{ id: 'ADAMO', name: 'Adamo' },
	{ id: 'AGRALE', name: 'Agrale' },
	{ id: 'ALFA-ROMEO', name: 'Alfa Romeo' },
	{ id: 'AM-GEN', name: 'Am Gen' },
	{ id: 'AMERICAR', name: 'Americar' },
	{ id: 'ASTON-MARTIN', name: 'Aston Martin' },
	{ id: 'AUDI', name: 'Audi' },
	{ id: 'BEACH', name: 'Beach' },
	{ id: 'BENTLEY', name: 'Bentley' },
	{ id: 'BIANCO', name: 'Bianco' },
	{ id: 'BMW', name: 'BMW' },
	{ id: 'BORGWARD', name: 'Borgward' },
	{ id: 'BRILLIANCE', name: 'Brilliance' },
	{ id: 'BUGATTI', name: 'Bugatti' },
	{ id: 'BUGGY', name: 'Buggy' },
	{ id: 'BUICK', name: 'Buick' },
	{ id: 'CADILLAC', name: 'Cadillac' },
	{ id: 'CBT', name: 'CBT' },
	{ id: 'CHAMONIX', name: 'Chamonix' },
	{ id: 'CHANA', name: 'Chana' },
	{ id: 'CHEDA', name: 'Cheda' },
	{ id: 'CHERY', name: 'Chery' },
	{ id: 'CHEVROLET', name: 'Chevrolet' },
	{ id: 'CHRYSLER', name: 'Chrysler' },
	{ id: 'CITROEN', name: 'Citroen' },
	{ id: 'CORD', name: 'Cord' },
	{ id: 'COYOTE', name: 'Coyote' },
	{ id: 'CROSS-LANDER', name: 'Cross Lander' },
	{ id: 'DAEWOO', name: 'Daewoo' },
	{ id: 'DAIHATSU', name: 'Daihatsu' },
	{ id: 'DE-SOTO', name: 'De Soto' },
	{ id: 'DELOREAN', name: 'Delorean' },
	{ id: 'DETOMAZO', name: 'Detomazo' },
	{ id: 'DITALLY', name: 'Ditally' },
	{ id: 'DKW-VEMAG', name: 'DKW-VEMAG' },
	{ id: 'DODGE', name: 'Dodge' },
	{ id: 'EAGLE', name: 'Eagle' },
	{ id: 'EFFA', name: 'EFFA' },
	{ id: 'ENGESA', name: 'Engesa' },
	{ id: 'ENVEMO', name: 'Envemo' },
	{ id: 'FARUS', name: 'Farus' },
	{ id: 'FERCAR', name: 'Fercar' },
	{ id: 'FERRARI', name: 'Ferrari' },
	{ id: 'FIAT', name: 'Fiat' },
	{ id: 'FNM', name: 'FNM' },
	{ id: 'FORD', name: 'Ford' },
	{ id: 'GAIOLA', name: 'Gaiola' },
	{ id: 'GEELY', name: 'Geely' },
	{ id: 'GEO', name: 'GEO' },
	{ id: 'GRANCAR', name: 'Grancar' },
	{ id: 'GREAT-WALL', name: 'Great Wall' },
	{ id: 'GURGEL', name: 'Gurgel' },
	{ id: 'HAFEI', name: 'Hafei' },
	{ id: 'HANOMAG', name: 'Hanomag' },
	{ id: 'HILLMAN', name: 'Hillman' },
	{ id: 'HOFSTETTER', name: 'Hofstetter' },
	{ id: 'HONDA', name: 'Honda' },
	{ id: 'HRG', name: 'HRG' },
	{ id: 'HUDSON', name: 'Hudson' },
	{ id: 'HUMMER', name: 'Hummer' },
	{ id: 'HYUNDAI', name: 'Hyundai' },
	{ id: 'INFINITI', name: 'Infiniti' },
	{ id: 'INTERNATIONAL', name: 'International' },
	{ id: 'JAC', name: 'JAC' },
	{ id: 'JAGUAR', name: 'Jaguar' },
	{ id: 'JEEP', name: 'JEEP' },
	{ id: 'JINBEI', name: 'Jinbei' },
	{ id: 'JPX', name: 'Jpx' },
	{ id: 'KAISER', name: 'Kaiser' },
	{ id: 'KARMANN GHIA', name: 'Karmann Ghia' },
	{ id: 'KART', name: 'Kart' },
	{ id: 'KASEA', name: 'Kasea' },
	{ id: 'KIA', name: 'Kia' },
	{ id: 'KOENIGSEGG', name: 'Koenigsegg' },
	{ id: 'LADA', name: 'Lada' },
	{ id: 'LAMBORGHINI', name: 'Lamborghini' },
	{ id: 'LANCIA', name: 'Lancia' },
	{ id: 'LAND-ROVER', name: 'Land Rover' },
	{ id: 'LAUTOCRAFT', name: 'Lautocraft' },
	{ id: 'LAUTOMOBILE', name: 'Lautomobile' },
	{ id: 'LEXUS', name: 'Lexus' },
	{ id: 'LIFAN', name: 'Lifan' },
	{ id: 'LINCOLN', name: 'Lincoln' },
	{ id: 'LOBINI', name: 'Lobini' },
	{ id: 'LOTUS', name: 'Lotus' },
	{ id: 'MAHINDRA', name: 'Mahindra' },
	{ id: 'MASERATI', name: 'Maserati' },
	{ id: 'MATRA', name: 'Matra' },
	{ id: 'MAYBACH', name: 'Maybach' },
	{ id: 'MAZDA', name: 'Mazda' },
	{ id: 'MCLAREN', name: 'Mclaren' },
	{ id: 'MENON', name: 'Menon' },
	{ id: 'MERCEDES-BENZ', name: 'Mercedes-Benz' },
	{ id: 'MERCURY', name: 'Mercury' },
	{ id: 'MG', name: 'MG' },
	{ id: 'MINI', name: 'Mini' },
	{ id: 'MITSUBISHI', name: 'Mitsubishi' },
	{ id: 'MIURA', name: 'Miura' },
	{ id: 'MORRIS', name: 'Morris' },
	{ id: 'MP LAFER', name: 'MP Lafer' },
	{ id: 'MPLM', name: 'MPLM' },
	{ id: 'NEWTRACK', name: 'Newtrack' },
	{ id: 'NISSAN', name: 'Nissan' },
	{ id: 'NISSIN', name: 'Nissin' },
	{ id: 'OLDSMOBILE', name: 'Oldsmobile' },
	{ id: 'OUTROS', name: 'OUTROS' },
	{ id: 'PAG', name: 'PAG' },
	{ id: 'PAGANI', name: 'Pagani' },
	{ id: 'PEUGEOT', name: 'Peugeot' },
	{ id: 'PLYMOUTH', name: 'Plymouth' },
	{ id: 'PONTIAC', name: 'Pontiac' },
	{ id: 'PORSCHE', name: 'Porsche' },
	{ id: 'PUMA', name: 'Puma' },
	{ id: 'RELY', name: 'Rely' },
	{ id: 'RENAULT', name: 'Renault' },
	{ id: 'RENO', name: 'Reno' },
	{ id: 'REVA-I', name: 'Reva-I' },
	{ id: 'ROLLS-ROYCE', name: 'Rolls-Royce' },
	{ id: 'ROMI', name: 'Romi' },
	{ id: 'SAAB', name: 'Saab' },
	{ id: 'SATURN', name: 'Saturn' },
	{ id: 'SEAT', name: 'Seat' },
	{ id: 'SHINERAY', name: 'Shineray' },
	{ id: 'SHORT', name: 'Short' },
	{ id: 'SIMCA', name: 'Simca' },
	{ id: 'SKODA', name: 'Skoda' },
	{ id: 'SMART', name: 'Smart' },
	{ id: 'SPYKER', name: 'Spyker' },
	{ id: 'SSANGYONG', name: 'Ssangyong' },
	{ id: 'STANDARD', name: 'Standard' },
	{ id: 'STUDEBAKER', name: 'Studebaker' },
	{ id: 'SUBARU', name: 'Subaru' },
	{ id: 'SUZUKI', name: 'Suzuki' },
	{ id: 'SWELL-MINI', name: 'Swell Mini' },
	{ id: 'TAC', name: 'TAC' },
	{ id: 'TANGER', name: 'Tanger' },
	{ id: 'TATA', name: 'TATA' },
	{ id: 'TOYOTA', name: 'Toyota' },
	{ id: 'TRIUMPH', name: 'Triumph' },
	{ id: 'TROLLER', name: 'Troller' },
	{ id: 'UNIMOG', name: 'Unimog' },
	{ id: 'UTILITARIOS-AGRICOLAS', name: 'Utilitarios Agricolas' },
	{ id: 'VOLKSWAGEN', name: 'Volkswagen' },
	{ id: 'VOLVO', name: 'Volvo' },
	{ id: 'WIESMANN', name: 'Wiesmann' },
	{ id: 'WILLYS-OVERLAND', name: 'Willys Overland' },
];

export const marcasPorId = [...optionsMarcasCarros, ...optionsMarcasMotos].reduce((marcasPorId, marca) => {
	marcasPorId[marca.id] = marca;
	return marcasPorId;
}, {});

export const marcas = Object.values(marcasPorId);

export default marcas;
